import { useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import { Fade } from '../Fade';
import layout from '../../styles/layout.module.css';
import { useContext } from 'react';
import { PreviewDataContext } from '../../context/PreviewContext';

const InBoxPreview = () => {
    const state = useSelector((state) => state.rootReducer);
    const currentModel = state.currentModel.currentModel;
    const inTheBox = currentModel.inTheBox;
    const topImage = inTheBox.topImage;
    const bottomImage = inTheBox.bottomImage;
    const { preview } = useContext(PreviewDataContext);

    return (
        <Fade visible delay={20} timeout={250}>
            <Box className={layout.outer}>
                <Box className={layout.below}>
                    <img
                        style={{
                            width: '100%'
                        }}
                        src={bottomImage}
                        alt="in-box"
                    />
                </Box>
                <Box className={layout.mid}>
                    <img src={preview} width={'100%'} />
                </Box>
                <Box className={layout.top}>
                    <img
                        style={{
                            width: '100%'
                        }}
                        src={topImage}
                        alt="in-box-top-cover"
                    />
                </Box>
            </Box>
        </Fade>
    );
};

export default InBoxPreview;
